<template>
  <div class="columns">
    <div class="column is-12-mobile is-12-desktop is-12-widescreen">
      <div class="level">
        <div class="level-left">
          <div class="title is-marginless is-paddingless">Spam businesses</div>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full-mobile is-3-tablet no-pad-left">
          <drop-down place-holder="Filter by date..." :items="filterList" v-on:changed="spamFilterSelected" :select-first-item-on-mount="selectFirstOption"></drop-down>
        </div>
      </div>
      <p v-if="!fetching_data" v-resultsCount="[total_records, all_records]"></p>
      <div class="level">
        <table v-if="items.length > 0" class="table is-size-7-touch is-marginless is-fullwidth">
          <thead>
          <tr>
            <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Date Published</td>
            <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Business</td>
            <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Reviewer email</td>
            <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">&nbsp;</td>
          </tr>
          </thead>
          <tbody>
          <tr class="margin-bottom-20" v-for="item in items" :key="item.id">
            <td class="is-narrow-mobile is-desktop break-all">{{item.created_at | prettyDateTime}} </td>
            <td class="is-narrow-mobile is-desktop break-all" :title="item.business_name"><span class="biz-name">{{ item.business_name }}</span></td>
            <td class="is-narrow-mobile is-desktop break-all"><a :href="`/reviewer-detail/${item.user_id}?status=&page=1`" v-if="item.user_email !== null" v-html="item.user_email"></a></td>
            <td class="is-narrow-mobile is-desktop break-all"><a :class="['button', {'is-loading' : deleting === item.id}]" @click.prevent="notSpam(item.id)" href="#">NOT&nbsp;SPAM</a></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="level">
        <paginator :dataSet="dataSet" @changed="getSpamRecords"></paginator>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef */
  import qs from 'qs'
  import moment from 'moment'
  import axios from 'axios'
  import Paginator from '@/components/Paginator'
  import DropDown from '@/components/DropDown'
  import misc from '../../mixins/misc.js'

  export default {
    mixins: [misc],
    name: 'SpamListingView',
    components: {
      Paginator,
      DropDown
    },
    data () {
      return {
        fetching_data: false,
        items: [],
        dataSet: {},
        total_records: 0,
        page: undefined,
        customAxios: undefined,
        selectFirstOption: true,
        deleting: 0,
        filterList: [
          {
            name: 'Today',
            value: 'today'
          },
          {
            name: 'Last 7 days',
            value: '7_days'
          },
          {
            name: 'Previous month',
            value: 'previous_month'
          },
          {
            name: 'Last 6 months',
            value: 'previous_6_months'
          },
          {
            name: 'Last 12 months',
            value: 'last_12_months'
          }
        ],
        currentFilter: '',
        all_records: -1
      }
    },
    created () {
      this.customAxios = axios.create({
        baseURL: process.env.SPAM_API_URL
      })
    },
    filters: {
      prettyDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      prettyTime (date) {
        return moment(date).format('HH:mm')
      }
    },
    methods: {
      /**
       * Get the businesses from the Spam REST Api that were automatically marked as Spam
       *
       * @param {Number|null} page - The page number to fetch
       *
       * @returns {void}
       */
      getSpamRecords (page = null) {
        this.page = page || 1
        this.fetching_data = true
        this.customAxios.get(this.url(page))
          .then((response) => {
            if (this.currentFilter) {
              this.customAxios.get(this.url(page, false))
                .then((response) => {
                  this.all_records = response.data.total
                })
            } else {
              this.all_records = -1
            }

            this.fetching_data = false
            this.refresh(response)
          })
          .catch(() => {
            this.fetching_data = false
          })
      },
      /**
       * Build the URL with the correct query string parameters
       *
       * @param {Number} page - The page number to pass to the URL builder
       * @param {Boolean} checkForFilter - Consider filter or not
       *
       * @returns {string}
       */
      url (page, checkForFilter = true) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        if (checkForFilter && this.currentFilter !== '') {
          const dateQuery = this.dateFilters(this.currentFilter)
          return `/api/businesses/?page=${page}&${dateQuery}`
        }
        return `/api/businesses/?page=${page}`
      },
      /**
       * Call the REST endpoint every time the spam filter drop-down change event is fired
       *
       * @param {object} event - The event on the change listener
       *
       * @returns {void}
       */
      spamFilterSelected (event) {
        this.currentFilter = event.value
        this.getSpamRecords()
      },
      /**
       * Calculate the date to be used for the REST endpoint and convert to a valid query string parameter
       *
       * @param {string} filter - The selected filter from the drop-down
       *
       * @returns {string}
       */
      dateFilters (filter) {
        let startDate = moment()

        switch (filter) {
          case '7_days':
            startDate.subtract(7, 'days')
            break
          case 'previous_month':
            startDate.subtract(1, 'month')
            startDate.startOf('month')
            break
          case 'previous_6_months':
            startDate.subtract(6, 'months')
            startDate.startOf('month')
            break
          case 'last_12_months':
            startDate.subtract(12, 'months')
            startDate.startOf('month')
            break
        }
        startDate = moment(startDate).format('YYYY-MM-DD')
        return qs.stringify({start_date: startDate})
      },
      /**
       * Update the Spam classifier result to mark as NOT spam and request API.V4 to create the
       * corresponding Business and Review
       *
       * @param {Number} spamId - The ID of the Spam record as stored in the Spam REST Api
       *
       * @returns {void}
       */
      notSpam (spamId) {
        this.deleting = spamId
        this.customAxios.put(`/api/businesses/${spamId}/`, {'is_spam': false})
          .then(({data}) => {
            axios.post(`/consumer/reviews/publish-from-spam`, data)
              .then(() => {
                flash('Successfully publish the review', 'is-success')
                this.getSpamRecords()
                this.deleting = 0
              })
              .catch(() => {
                flash('There was an error trying to publish the review', 'is-danger')
                this.deleting = 0
              })

            axios.post(`/business/${data.id}/add-to-elastic`)
          })
          .catch(() => {
            flash('There was an error when trying to \'un-spam\' the record', 'is-danger')
            this.deleting = 0
          })
      }
    }
  }
</script>
<style scoped>
  .no-pad-left {
    padding-left: 0!important;
  }
  span.biz-name {
    display: inline-block;
    width: 366px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/pages/spam/SpamListing.vue